module.exports = __webpack_public_path__ + "static/shopify-85d7deb78e091debb3236a0e6d7ba85a.png";